import { TmcContextService } from './../../../../../../../common/tmc-context.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ProcessingStatus } from '../../../../../../../client/model/processing-status';

import { TranslationService } from '@sdbn/common';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { FilterCondition } from '../../../../filter-administration.model';
import { FilterAdministrationContext } from '../../../../filter-administration.context';

@Component({
  selector: 'app-processing-status-editor',
  templateUrl: './processing-status-editor.component.html',
  styleUrls: ['./processing-status-editor.component.scss']
})
export class ProcessingStatusEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  processingStatus: ProcessingStatus[] = [];

  tmcContextSubscription: Subscription;

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

    for (const processingStatusModel of this.tmcContextService.getYardConfiguration().processingStatusModels) {
      if (processingStatusModel.key === 'default') {
        this.processingStatus = processingStatusModel.status;
        break;
      }
    }

    this.detailsFormGroup.addControl('processingStatus', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.processingStatus = this.detailsFormGroup.controls.processingStatus.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }
}
